<template>
  <div class="container-login bg-primary">
    <div class="container-dados">
      <div class="container">
        <div class="row justify-content-center align-items-center">
          <div class="col-md-6 col-lg-5 text-center text-white d-none d-md-block">
            <div class="logo-lecard"><img src="../assets/logo-white.png" alt="Logo LeCard"></div>
          </div>
          <div class="col-md-6 col-lg-5">
            <div class="card shadow-sm border-0 mx-auto" style="max-width: 360px">
              <div class="card-body pb-4">
                <div><img src="../assets/logo-lecard.png" alt="Logo LeCard" style="width: 32px"></div>
                <div>
                  <h5 class="mt-2 mb-1">LeBot | Login</h5>
                </div>
                <div class="mt-4">
                  <form @submit.prevent="logar">
                    <div class="form-group">
                      <input type="text" id="usuario" v-model="dados.username" class="form-control" placeholder="E-mail"
                             minlength="4" required>
                    </div>
                    <div class="form-group input-senha">
                      <input :type="showPassword ? 'text' : 'password'" id="inputSenha" class="form-control" v-model="dados.password" placeholder="Senha" autocomplete="password" required>
                      <i class="fa" :class="showPassword ? 'fa-eye-slash' : 'fa-eye'" @click="showPassword = !showPassword" v-show="dados.password.length > 0"
                         :title="showPassword ? 'Esconder senha' : 'Mostrar senha'"></i>
                    </div>
                    <div class="form-group">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="checkboxSenha" @change="salvarUser = !salvarUser" :checked="salvarUser">
                        <label class="custom-control-label" for="checkboxSenha">Salvar Usuário</label>
                      </div>
                    </div>
                    <button class="btn btn-primary btn-block py-2" :disabled="loading">{{loading ? 'Aguarde' : 'Login'}}</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-botton text-white">
      <div class="container pb-3 text-center">
        <p class="m-0 small">Uma empresa da <a href="https://storkdigital.com.br" class="text-white font-weight-bold" target="_blank">Agência Stork</a></p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Login',
    data() {
      return {
        loading: false,
        salvarUser: true,
        showPassword: false,
        dados: {
          username: '',
          password: ''
        }
      }
    },
    methods: {
      logar() {
        this.loading = true;

        this.$http.post('agents/login', this.dados, {
          skipJwtRefresh: true
        })
          .then(res => {
            if (res.data.success) {
              this.setToken(res.data);
            }

          }, res => {
            console.log(res);
            this.loading = false;

            if (res.status === 401) {
              this.dados.password = '';
              this.$swal("Usuário ou senha inválidos.");
              return;
            }

            if (res.status === 429) {
              this.dados.password = '';
              this.$swal("Muitas tentativas de login. Aguarde alguns minutos e tente novamente.");
              return;
            }

            this.$swal("Não foi possível realizar o login. Tente novamente.");
          });
      },

      setToken(data) {
        this.$auth.applyTokens(data, false);

        if (this.salvarUser) {
          localStorage.setItem("email", this.dados.username);
        } else {
          localStorage.removeItem("email");
        }

        window.location.href = sessionStorage.getItem('redirect') || "/";
      }
    },

    mounted() {
      if (!localStorage.getItem('refresh_token')) {
        this.loading = false;

        if (localStorage.getItem("email")) {
          this.dados.username = localStorage.getItem("email");
          this.salvarUser = true;

          setTimeout(() => {
            document.getElementById("inputSenha").focus()
          }, 500)
        }

      } else {
        this.$router.push('/chat');
      }
    }
  }
</script>

<style scoped>
.container-login {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.container-botton {
  position: absolute;
  width: 100%;
  z-index: 1;
  bottom: 0;
}
.container-top {
  position: absolute;
  z-index: 1;
  width: 100%;
}
.container-dados {
  position: absolute;
  top: 48%;
  transform: translateY(-50%);
  width: 100%;
}
.logo-top {
  width: 72px;
}
.logo-lecard img {
  width: 350px;
  object-fit: cover;
}

.input-senha {
  position: relative;
}

.input-senha i {
  position: absolute;
  top: 11px;
  right: 10px;
  cursor: pointer;
  display: block;
  width: 20px;
}

@media (max-width: 767px) {
  .logo-top {
    width: 96px;
    object-fit: cover;
    padding-top: 12px;
  }

  .container-top {
    text-align: center;
    background-color: var(--primary);
  }

  .container-dados {
    padding-top: 0;
  }
}

@media (max-height: 550px) {
  .container-login {
    position: static;
  }
  .container-dados {
    position: static;
    transform: none;
    padding: 132px 0 32px;
  }
  .container-botton {
    position: static;
  }
}
</style>
